import { render, staticRenderFns } from "./TransferModel.vue?vue&type=template&id=98654e20&"
import script from "./TransferModel.vue?vue&type=script&lang=js&"
export * from "./TransferModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports